// extracted by mini-css-extract-plugin
module.exports = {"Social":"Social_Social__3qt5o","socialLink":"Social_socialLink__M5VNj","Icon":"Social_Icon__nZk1M"};